import { useRouter } from "next/router";

import { Button, Card } from "@chef/components";
import { Check } from "@chef/icons/small";
import { Modal } from "@chef/smart-components";
import { useUpdateUserConsentsMutation } from "@chef/state-management";
import { BRAND_NAME, BRAND_PATHS, CONSENT_IDS } from "@chef/constants";

import { intl } from "./ConsentsWarningModal.Intl";

interface Props {
  open: boolean;
}

export const ConsentsWarningModal = ({ open }: Props) => {
  const router = useRouter();
  const [updateUserConsentsMutation, { isLoading }] =
    useUpdateUserConsentsMutation();

  const BENEFITS = [
    intl.SAVE_YOUR_ALLERGY_PREFERENCES,
    intl.AVOID_RECIEVING_FOOD_YOU_DISLIKE,
    intl.BETTER_RECOMMENDATIONS,
  ];

  const onClose = () => {
    router.push(BRAND_PATHS.MY_SUBSCRIPTION_LINK);
  };

  const handleApprove = async () => {
    await updateUserConsentsMutation([
      {
        consentId: CONSENT_IDS.DATA_PROCESSING[BRAND_NAME],
        isAccepted: true,
      },
      {
        consentId: CONSENT_IDS.ALLERGEN_STORING[BRAND_NAME],
        isAccepted: true,
      },
    ]);
    onClose();
  };

  return (
    <Modal open={open} animation="fly-up" onClose={onClose} size="sm">
      {/* TODO: added mt-44 to bring the modal more to middle of the screen, work out how we can position it properly (at the bottom for mobile) */}
      <Card className="flex flex-col justify-center gap-6 px-4 py-10 mt-44">
        <div className="flex flex-col gap-4">
          <div className="text-center">
            <h1 className="text-xl">
              <strong>{intl.HELP_US_IMPROVE_EXPERIENCE}</strong>
            </h1>
            <p className="text-sm">{intl.DO_WE_HAVE_YOUR_APPROVAL}</p>
          </div>
          <div className="flex flex-col gap-3 p-4 rounded bg-informationBG">
            {BENEFITS.map((BENEFIT) => (
              <div key={BENEFIT} className="flex items-center gap-3">
                <div className="justify-start w-4">
                  <Check className="mb-2 w-4 p-0.75 text-white rounded-full bg-information" />
                </div>
                <p className="text-sm">{BENEFIT}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <Button primary onClick={handleApprove} loading={isLoading}>
            {intl.I_APPROVE}
          </Button>
          <Button outlined onClick={onClose} disabled={isLoading} tiny>
            {intl.I_DONT_WANT_IT}
          </Button>
        </div>
      </Card>
    </Modal>
  );
};
